<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle">{{ $t('sale.sale_products-for-sale') }}</div>
    <div class="textStyle px-5" v-if="search">
      <v-text-field
        v-bind:value="input.keyword"
        @input="inputKeyword"
        :placeholder="$t('sale.sale_input-keywords')"
        outlined
        dense
        hide-details
      >
      </v-text-field>
    </div>
    <div class="mr-1" v-if="search">
      <SelectProductCategory v-model="input.category" />
    </div>
    <NormalTextButton
      v-if="authority.isAdmin || authority.isUser"
      :text="'＋ ' + $t('order.order_product-registration')"
      class="textButtonStyle"
      @click="dialogInfo.register = true"
    />
    <MasterProductDialog
      v-model="dialogInfo.register"
      @success="registerSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { NormalTextButton, SelectProductCategory } from '@/components/items'
import { MasterProductDialog } from '@/components/layouts/Dialogs'

export default {
  components: {
    NormalTextButton,
    SelectProductCategory,
    MasterProductDialog
  },
  data: () => ({
    input: {
      keyword: '',
      category: ''
    },
    dialogInfo: {
      register: false
    }
  }),
  props: {
    search: { default: true }
  },
  methods: {
    inputKeyword(event) {
      this.$emit('inputKeyword', event)
    },
    registerSuccess() {
      this.$emit('productRegisterSuccess')
      this.dialogInfo.register = false
    }
  },
  computed: {
    ...mapGetters('User', ['authority'])
  },
  watch: {
    'input.category': {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('selectCategory', newVal)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.searchAreaStyle {
  height: 70px;
}
.selectBoxStyle {
  width: 340px;
  //   margin: 0px 16px 0px 63px !important;
  margin-left: 30px;
  margin-right: 20px;
}
.textButtonStyle {
  margin: 0px 21px;
}
.textStyle {
  width: 280px;
}
</style>
